module.exports = __webpack_public_path__ + "static/img/10.a1b0d10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/sp/10.png
// module id = 3REy
// module chunks = 0